import { Api} from '../axioscadastro';

interface ContasReceber {
  numero: number;
  emissao: string;
  fabrica: string;
  descricao: string;
  multiplo: number;
  cliente: string;
  cpf: string;
  telefone: number; 
  totalnota: number;
  total: number;
}
interface IVendasfabrica {
  quantidade: number;
  ean: string;
  descricao: string;
  preco: number;
  total: number;
}
interface IVendasfabricacliente {
  emissao: string;
  nome: string;
  numero: number;
  total: number;
}
interface IVendasfabricadetalhes {
  emissao: string;
  nome: string;
  numero: number;
  quantidade: number;
  ean: string;
  descricao: string;
  preco: number;
  total: number;
}
interface IEstoqueFabrica {
  idprod: string;
  descricao: string;
  ean: string;
  codfabrica: string;
  valor: number;
  estoque: number;
  total: number;
}

const RelatorioVendas = async (grupo: string, idcli: string, datainicial: string, datafinal: string): Promise<ContasReceber[] | Error> => {
  try {
    const urlRelativa = `/rpedidoporcliente?participante=${idcli}&grupo=${grupo}&inicial=${datainicial}&final=${datafinal}`;      
    const { data } = await Api.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};
const RelatorioVendasfabrica = async (fabrica: string, operacao: string, porcliente: boolean, detalhes: boolean, datainicial: string, datafinal: string): Promise<IVendasfabrica[] | Error> => {
  try {
    const urlRelativa = `/rpedidoporfabrica?fabrica=${fabrica}&operacao=${operacao}&porcliente=${porcliente}&detalhes=${detalhes}&inicial=${datainicial}&final=${datafinal}`;
    const { data } = await Api.get(urlRelativa);

    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};
const RelatorioVendasfabricacliente = async (fabrica: string, operacao: string, porcliente: boolean, detalhes: boolean, datainicial: string, datafinal: string): Promise<IVendasfabricacliente[] | Error> => {
  try {
    const urlRelativa = `/rpedidoporfabrica?fabrica=${fabrica}&operacao=${operacao}&porcliente=${porcliente}&detalhes=${detalhes}&inicial=${datainicial}&final=${datafinal}`;
    const { data } = await Api.get(urlRelativa);

    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};
const RelatorioVendasfabricadetalhes = async (fabrica: string, operacao: string, porcliente: boolean, detalhes: boolean, datainicial: string, datafinal: string): Promise<IVendasfabricadetalhes[] | Error> => {
  try {
    const urlRelativa = `/rpedidoporfabrica?fabrica=${fabrica}&operacao=${operacao}&porcliente=${porcliente}&detalhes=${detalhes}&inicial=${datainicial}&final=${datafinal}`;
    const { data } = await Api.get(urlRelativa);

    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const RelatorioEstoque = async (fabrica: string): Promise<IEstoqueFabrica[] | Error> => {
  try {
    const urlRelativa = `/rprodutos?fabrica=${fabrica}`;
    const { data } = await Api.get(urlRelativa);

    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};
  

export const Relatorios = {
  RelatorioVendas,
  RelatorioVendasfabrica,
  RelatorioVendasfabricacliente,
  RelatorioVendasfabricadetalhes,
  RelatorioEstoque
};